import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { PatientService } from '../../../services/patient.service';
import { ErrorPanelService } from '../../../services/error-panel.service';
import { Patient } from '../../../models/patient-model';
import { LoaderStandaloneComponent } from './loader-standalone/loader-standalone.component';

@Component({
  selector: 'app-top-bar-search',
  standalone: true,
  imports: [FormsModule, MatIconModule, LoaderStandaloneComponent],
  templateUrl: './top-bar-search.component.html',
  styleUrl: './top-bar-search.component.scss',
})
export class TopBarSearchComponent {
  @ViewChild('searchInput') searchInput!: ElementRef;

  isSearchOpen = false;
  searchText = '';
  patients: Patient[] = [];
  filteredPatients: Patient[] = [];

  isLoadingPatients = true;

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isSearchOpen = false;
      this.searchText = '';
      this.filterPatients();
    }
  }

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private patientService: PatientService,
    private errorPanelService: ErrorPanelService
  ) {}

  toggleSearch() {
    if (this.patients.length === 0) {
      this.getPatients();
    }
    this.isSearchOpen = !this.isSearchOpen;
    if (this.isSearchOpen) {
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      });
    } else {
      this.searchText = '';
      this.filterPatients();
    }
  }

  getPatients() {
    this.isLoadingPatients = true;
    this.patientService.getPatients().subscribe({
      next: (patients: Patient[]) => {
        this.patients = patients.sort((a, b) =>
          a.last_name.localeCompare(b.last_name)
        );
        this.filteredPatients = [...this.patients];
        this.isLoadingPatients = false;
      },
      error: (error: any) => {
        console.error('Error fetching patients:', error);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recupero dei pazienti'
        );
        this.isLoadingPatients = false;
      },
    });
  }

  filterPatients() {
    if (!this.searchText) {
      this.filteredPatients = [...this.patients];
      return;
    }

    const searchLower = this.searchText.toLowerCase();
    this.filteredPatients = this.patients.filter(
      (patient) =>
        patient.first_name.toLowerCase().includes(searchLower) ||
        patient.last_name.toLowerCase().includes(searchLower)
    );
  }

  navigateToPatientPage(patient: Patient) {
    this.router.navigate([`/pazienti/${patient.id}`]);
  }
}
